import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTheme } from '@emotion/react';
import { tree } from 'd3-state-visualizer';
import { getPath } from '../ChartMonitorWrapper.js';
import { updateMonitorState } from '../../../actions/index.js';
const style = {
    width: '100%',
    height: '100%',
};
class ChartTab extends Component {
    constructor() {
        super(...arguments);
        this.getRef = (node) => {
            this.node = node;
        };
        this.onClickText = (data) => {
            const inspectedStatePath = [];
            getPath(data, inspectedStatePath);
            this.props.updateMonitorState({
                inspectedStatePath,
                subTabName: data.children ? 'Chart' : 'Tree',
            });
        };
    }
    shouldComponentUpdate() {
        return false;
    }
    componentDidMount() {
        this.createChart(this.props);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.theme.scheme !== nextProps.theme.scheme ||
            nextProps.theme.light !== this.props.theme.light) {
            this.node.innerHTML = '';
            this.createChart(nextProps);
        }
        else if (nextProps.data !== this.props.data) {
            // eslint-disable-next-line @typescript-eslint/no-empty-object-type
            this.renderChart(nextProps.data);
        }
    }
    createChart(props) {
        this.renderChart = tree(this.node, this.getChartTheme(props.theme));
        // eslint-disable-next-line @typescript-eslint/no-empty-object-type
        this.renderChart(props.data);
    }
    getChartTheme(theme) {
        return {
            heightBetweenNodesCoeff: 1,
            widthBetweenNodesCoeff: 1.3,
            tooltipOptions: {
                styles: {
                    color: theme.base06,
                    'background-color': theme.base01,
                    opacity: '0.9',
                    'border-radius': '5px',
                    padding: '5px',
                },
                offset: { left: 30, top: 10 },
                indentationSize: 2,
            },
            chartStyles: {
                width: '100%',
                height: '100%',
            },
            nodeStyleOptions: {
                colors: {
                    default: theme.base0B,
                    collapsed: theme.base0B,
                    parent: theme.base0E,
                },
                radius: 7,
            },
            textStyleOptions: {
                colors: {
                    default: theme.base0D,
                    hover: theme.base06,
                },
            },
            onClickText: this.onClickText,
        };
    }
    render() {
        return React.createElement("div", { style: style, ref: this.getRef });
    }
}
const actionCreators = {
    updateMonitorState,
};
const ConnectedChartTab = connect(null, actionCreators)(ChartTab);
export default withTheme(ConnectedChartTab);
